var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.transformer)?_c('div',[_c('FormHelper',{ref:"form",attrs:{"form":_vm.form,"config":_vm.config,"no-data-text":_vm.$t('mapping.noTransformersAvailable')},model:{value:(_vm.formTransformer),callback:function ($$v) {_vm.formTransformer=$$v},expression:"formTransformer"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }